import { z } from 'zod'

export const rejectPaymentAdvanceSchema = z.object({
  reject_reason: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type RejectPaymentAdvanceValidationSchema = z.infer<typeof rejectPaymentAdvanceSchema>
